import Link from 'next/link';
import { IoChevronForward } from 'react-icons/io5';

import { Anchor, Group, Stack, Text } from '@mantine/core';

import { CompanyProfile, PublishedStatus } from 'models';
import { CompanyHelpers } from 'helpers/CompanyHelpers';

import { BoothNumber } from 'components/booth-number/BoothNumber';
import { useCompanyEvent } from 'components/company-profile/hooks/use-company-event';
import { Logo } from 'components/company-profile-teaser/components/Logo';
import { useIsMobile } from 'hooks/use-is-mobile';

import cx from './CompanyHeroHeader.module.scss';

const CompanyHeroHeader = ({ company, link }: { company: CompanyProfile; link?: { label: string; href: string } }) => {
    const { event } = useCompanyEvent(company);
    const isMobile = useIsMobile('sm');

    const companyLink =
        link ??
        (company.status === PublishedStatus.PUBLISHED
            ? { label: 'View profile', href: CompanyHelpers.urls.view(company.slug) }
            : null);

    return (
        <Group justify="space-between" align="center" wrap="nowrap" gap="lg">
            <Group gap="sm" wrap="nowrap" miw={0}>
                <Link href={CompanyHelpers.urls.view(company.slug)} className={cx.logo}>
                    <Logo company={company} withBorder size={isMobile ? 40 : undefined} />
                </Link>
                <Stack gap={0} miw={0}>
                    <Text fw={700} lineClamp={1} className={cx.name}>
                        {company.name}
                    </Text>
                    {companyLink && (
                        <Anchor component={Link} href={companyLink.href} className={cx.link}>
                            {companyLink.label}
                            <IoChevronForward size={14} />
                        </Anchor>
                    )}
                </Stack>
            </Group>
            {event && (
                <BoothNumber
                    event={event}
                    company={company}
                    showEventName={false}
                    style={{ flexShrink: 0, whiteSpace: 'nowrap' }}
                />
            )}
        </Group>
    );
};

export { CompanyHeroHeader };
